<template>
  <v-container>
    <v-layout justify-center align-center>
      <v-flex md8>
        <v-card elevation="3">
          <v-card-text>
            <v-row dense class="pa-5">
              <v-col cols="6">
                <v-file-input
                  v-model="chosenFile"
                  show-size small-chips
                  label="Cargar Arhivo"
                  @change="setFile"
                  outlined
                  dense>
                </v-file-input>
              </v-col>
              <v-col cols="6">
                <SelectedMain :itemAction="selectActividadField" :on-success="tipoActividad" :on-error="errorComponents" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn class="green darken-1 mr-3" dark outlined @click="send">
                <v-icon left> mdi-cloud-upload </v-icon>Guardar
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectedMain from '@/components/fields/selectedMain'
export default {
  data: () => ({
    selectActividadField: {
      name: 'Tipo Actividad',
      nameid: 'tipoActividadId',
      url: '/tipo-actividades',
      value: 'id'
    },
    typeImport: 'json',
    results: null,
    message: '',
    chosenFile: null,
    sendImport: {
      data: {}
    }
  }),
  components: {
    SelectedMain
  },
  methods: {
    tipoActividad (obj) {
      console.log('obj', obj)
      if (obj) {
        this.sendImport[obj.id] = (obj.data === undefined) ? null : obj.data
      }
    },
    errorComponents (field) {
      if (field.nameid === 'tipo_proceso_id') {
        console.log('field', field)
      }
    },
    beforeUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 20
      if (isLt1M) {
        return true
      }
      console.log({
        message: isLt1M + ' --Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    handleSuccess (excelData) {
      if (excelData.Numberpage === 1) {
        this.message = `se agrego 1 pestaña con ${excelData[excelData.page[0]].results.length} Registros`
      } else {
        let rows = 0
        excelData.page.map(name => {
          rows += excelData[name].results.length
        })
        this.message = `se agrego ${excelData.Numberpage} pestañas, total de regisros ${rows}`
      }
      this.sendImport.data.results = excelData
      this.results = excelData
    },
    setFile (file) {
      this.chosenFile = file
      this.sendImport.data = file
    },
    ...mapActions(['postUrlImportCatalogDataServerAction']),
    send () {
      if (!this.chosenFile) {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'Debe Agregar un Archivos Excel'
        })
        return
      }
      if (!this.sendImport.tipoActividadId) {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'Debe agregar el tipo de inventario'
        })
        return
      }
      this.postUrlImportCatalogDataServerAction(this.sendImport)
    }
  },
  computed: {
    ...mapGetters(['get_objectImport'])
  },
  watch: {
    typeImport () {
      this.results = null
      this.chosenFile = null
      this.message = ''
    },
    get_objectImport (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Importacion realizada correctamente'
      })
    }
  }
}
</script>

<style>

</style>
